import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Healthscale img
import breathing_grey from '../../Images/Healthform/health_grey.png';
import breathing_green from '../../Images/Healthform/health_green.png';

class NivBreathingLeakageResDisplay extends Component {
    //Function to display form res alert logo with the good color
    getFormResImg(){
        let unit = ""
        if (this.props.formresBreathingDisplay.res !== undefined && this.props.formresBreathingDisplay.res !== "-"){
            unit = <FormattedMessage id="patientConstants.VNIleakageUnit" defaultMessage="" />
        }

            return (
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"1%"}}>
                <Col style={{ width:"100%" }}>
                    <FormattedMessage id="patientConstants.VNIleakage" defaultMessage="" />
                </Col>
                <Col style={{ width:"100%" }}>
                    <span id="row-measure-style" style={{color: this.props.formresBreathingDisplay.color}}>{this.props.formresBreathingDisplay.res}</span>
                    <span id="row-unit-style" style={{color: this.props.formresBreathingDisplay.color}}>{unit}</span>
                </Col>
                </Row>
            )
    }

    display_value(){

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormResImg()
                }
            </Row>
        )
    }    

    //Display render
    render(){

        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
    }
}
export default (NivBreathingLeakageResDisplay);